/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:15:37
 * @Last Modified by:   MWeiLiu
 * @Last Modified time: 2019-12-17 20:15:37
 */

import router from './router'
import mould from './mould'
import guard from './guard'
import Common from '../assets/js/common'

router.beforeEach((to, from, next) => {
  var routeManagement = Common.routeManagement({
    to: to,
    guard: guard,
    store: router.app.$options.store,
    router: router
  })

  if (routeManagement.code === -1) {
    router.push(mould.login)
    return
  } else if (routeManagement.code === 0) {
    router.push(mould.index)
    return
  } else if (routeManagement.code === 404) {
    router.push(mould.notFind)
    return
  }

  let docEl = document.documentElement || document.body
  let clientWidth = docEl.clientWidth || window.innerWidth
  let Parr = ['index', 'information', 'informationcon', 'inorganic', 'boutique', 'boutiquecon', 'boutiquecon1', 'statistics']
  let Marr = ['mindex', 'minformation', 'minformationcon', 'minorganic', 'mboutique', 'mboutiquecon', 'mboutiquecon1', 'mstatistics']
  if (clientWidth <= 750) {
    for (var i = 0; i < Parr.length; i++) {
      if (to.name === Parr[i]) {
        next({
          path: mould[Marr[i]].path,
          query: to.query
        })
        return
      }
    }
  } else {
    for (var j = 0; j < Marr.length; j++) {
      if (to.name === Marr[j]) {
        next({
          path: mould[Parr[j]].path,
          query: to.query
        })
        return
      }
    }
  }

  next()
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js